import { Box, Typography } from "@mui/material";
import ModalContent from "../ModalContent/ModalContent";
import { useModal, useStore } from "src/Shared/Hooks";
import GridFormControl from "../GridFormControl/GridFormControl";
import { useEffect, useMemo, useState } from "react";
import { fields } from "./fields";
import { IGridFormControlProps } from "src/Shared/Interfaces/IGridFormControlProps.interface";
import { getFormValidation } from "../FormValidations";
import { EDITOR_TYPES } from "src/Shared/Enums";
import { IActionNote } from "src/Modules/Company/Interfaces/IActionNote";
import { observer } from "mobx-react";
type Props = {
  updateAction?: (val: IActionNote) => void;
  content?: string;
  isMarkAsCompleted?: boolean;
  title: string;
  label?: string;
  additionalValidation?: string;
  validationMessages?: { [key: string]: string };
};
const AddNoteConfirmation: React.FC<Props> = ({
  content,
  updateAction,
  isMarkAsCompleted,
  title,
  label = "Note",
  additionalValidation = "",
  validationMessages = {},
}) => {
  const {
    rootStore: {
      salesActionStore: { isNoteBtnLoading },
    },
  } = useStore();

  const { close } = useModal();

  const getValidation = () => {
    return "string" + (additionalValidation ? `|${additionalValidation}` : "");
  };

  const getHelperText = () => {
    return getField("note").error;
    // const errorKey = getField("note").error;
    // return errorKey && validationMessages[errorKey]
    //   ? validationMessages[errorKey]
    //   : getField("note").error || "";
  };

  const noteForm = useMemo(() => {
    return getFormValidation(fields(label, getValidation));
  }, []);

  const getField = (key: string) => noteForm.$(key);
  const gridPropsForNote: IGridFormControlProps = {
    row: 1,
    col: 1,
    itemResponsive: {
      lg: 12,
      sm: 12,
      md: 4,
    },
    inputControls: [
      {
        field: getField("note"),
        fieldKey: "note",
        type: EDITOR_TYPES.TEXT_FIELD,
        multiline: true,
        rows: 3,
        helperText: getHelperText(),
      },
    ],
    form: noteForm,
  };

  const onConfirm = () => {
    if (!noteForm.isValid) {
      noteForm.showErrors();
      return;
    }
    const request: IActionNote = { ...noteForm.values() };
    request.isMarkAsCompleted = isMarkAsCompleted;
    updateAction(request);
  };

  return (
    <ModalContent
      maxWidth="xs"
      title={title}
      btnLoading={isNoteBtnLoading}
      buttonText="Confirm"
      onSaveButtonClick={() => onConfirm()}
      cancelButton={true}
      onCancel={() => close()}
    >
      <GridFormControl {...gridPropsForNote} />
      {isMarkAsCompleted && <Typography>{content}</Typography>}
    </ModalContent>
  );
};

export default observer(AddNoteConfirmation);
